import React from 'react';
import { Lock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../../../components/button';

export type UpgradeToUnlockVariant = 'button' | 'pill';

interface UpgradeToUnlockButtonProps {
    className?: string;
    variant?: UpgradeToUnlockVariant;
}

export const UpgradeToUnlockButton: React.FC<UpgradeToUnlockButtonProps> = ({
    className = '',
    variant = 'button',
}) => {
    const navigate = useNavigate();

    if (variant === 'pill') {
        return (
            <button
                type="button"
                onClick={() => navigate('/merchant/my-plan')}
                className={`
                    inline-flex items-center gap-2 px-3 py-1.5 rounded-full
                    bg-[#FFB84D] hover:bg-[#f5a623] text-white
                    text-[12px] font-semibold font-['Segoe_UI'] leading-4
                    transition-colors ${className}
                `}
            >
                <Lock className="w-3.5 h-3.5" strokeWidth={2} />
                Upgrade to unlock
            </button>
        );
    }

    return (
        <Button
            type="button"
            variant="outline"
            onClick={() => navigate('/merchant/my-plan')}
            className={`text-[#ea580c] dark:text-orange-500 border-[#ea580c] dark:border-orange-500 hover:bg-orange-50 dark:hover:bg-orange-950/30 hover:border-orange-600 dark:hover:border-orange-400 ${className}`}
        >
            Upgrade to unlock
        </Button>
    );
};
